// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"c0649807","453":"6b9f3e8b"}[chunkId] + ".chunk.js";
};